export const PREFIX = 'PROFILE_STOCKS';
